import clsx from "clsx";
import { CommunityFormEnum } from "../../../../community/enums/CommunityFormEnum"

type Props = {
    section: CommunityFormEnum;
    setSection: (section: CommunityFormEnum) => void;
}

export const ProfileMemberCommunityTab = ({ section, setSection }: Props) => {

    return (
        <div className="nb-pm-tabs">
            <div className="tap-flex-center">
                <div 
                    className={clsx("nb-pm-tabs__item mr_1", { 'nb-pm-tabs__item--active': section === CommunityFormEnum.OPEN_DISCUSSION })}
                    onClick={() => setSection(CommunityFormEnum.OPEN_DISCUSSION)}
                >
                    Forum
                </div>
                <svg width='1' height='20' viewBox='0 0 1 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M0.5 0V20' stroke='#B4B4B4' />
                </svg>
            </div>
            <div className="tap-flex-center">
                <div 
                    className={clsx("nb-pm-tabs__item mr_1", { 'nb-pm-tabs__item--active': section === CommunityFormEnum.MASTERMIND_CIRCLE })}
                    onClick={() => setSection(CommunityFormEnum.MASTERMIND_CIRCLE)}    
                >
                    Mastermind Circles
                </div>
            </div>
        </div>
    )
}